import { AudioManager } from '../core/AudioManager';
import { InfractionLog, StVOInfraction } from './InfractionLog';
import { RuleEvaluators } from './RuleEvaluators';

export interface ExaminerMessage {
  id: string;
  sender: string;
  text: string;
  isWarning: boolean;
  timestamp: number;
}

export class StVOExaminer {
  public name: string = 'Fahrprüfer Müller (TÜV)';
  public currentMessage: ExaminerMessage | null = null;
  public messageHistory: ExaminerMessage[] = [];
  /**
   * Examiner Talk-Back / TTS state.
   * OFF by default so the driving student is not distracted and only sees
   * the compact turn-by-turn directions banner and driving mistakes display.
   */
  public talkBackEnabled: boolean = false;

  constructor(
    private audioManager: AudioManager,
    public infractionLog: InfractionLog,
    public ruleEvaluators: RuleEvaluators
  ) {}

  public setTalkBackEnabled(enabled: boolean) {
    this.talkBackEnabled = enabled;
    if (!enabled) {
      this.audioManager.stopExaminerSpeech();
    }
  }

  public say(text: string, isWarning: boolean = false, speakAudio: boolean = true, audioKey?: string) {
    const msg: ExaminerMessage = {
      id: Math.random().toString(36).substring(2, 9),
      sender: this.name,
      text,
      isWarning,
      timestamp: Date.now(),
    };

    this.currentMessage = msg;
    this.messageHistory.push(msg);

    if (isWarning) {
      this.audioManager.playAlertBeep(isWarning);
    }

    if (speakAudio && this.talkBackEnabled) {
      this.audioManager.speakExaminer(text, undefined, audioKey);
    }
  }

  public reportInfraction(infraction: StVOInfraction) {
    const prefix = infraction.severity === 'FATAL' ? '🚨 SCHWERER FEHLER: ' : '⚠️ HINWEIS: ';
    this.say(`${prefix}${infraction.title}! ${infraction.description}`, infraction.severity === 'FATAL');
  }

  public clearCurrentMessage() {
    this.currentMessage = null;
  }
}
